import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-note-card',
  imports: [CommonModule, FormsModule, MatButtonModule, MatCardModule, MatFormFieldModule, MatInputModule],
  templateUrl: './note-card.component.html',
  styleUrl: './note-card.component.scss'
})
export class NoteCardComponent implements OnInit {
  @Input() customClass: string = '';
  @Input() noButton: string = 'Cancel';
  @Input() placeHolder: string = 'placeholder';
  @Input() isRequired: boolean = false;
  @Input() textLength: number | null = null;
  @Input() textRows: number = 4;
  @Input() title: string = 'Note';
  @Input() top: number = 0;
  @Input() value: string = '';
  @Input() yesButton: string = 'Save';

  @Output() closeNote = new EventEmitter();
  @Output() confirmNote = new EventEmitter<string>();
  @Output() valueChange = new EventEmitter<string>();

  public currentDateTime: WritableSignal<Date> = signal(new Date());
  public isTouched: WritableSignal<boolean> = signal(false);
  public isValid: WritableSignal<boolean> = signal(false);

  public ngOnInit(): void {
    this.isValid.set(this.checkValidation());
  }

  public onClose(): void {
    this.closeNote.emit();
  }

  public onConfirm(value: string): void {
    this.valueChange.emit(this.value);
    this.confirmNote.emit(value);
  }

  public onInputChange(event: Event): void {
    this.value = (<HTMLTextAreaElement>event.target).value;
    this.isTouched.set(true);
    this.isValid.set(this.checkValidation());
  }

  private checkValidation(): boolean {
    return this.value.trim().length > 0;
  }
}
